export const useMocks =
    (process.env.npm_lifecycle_event && process.env.npm_lifecycle_event.startsWith('start:mocked')) || false;
